import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('IconDynamic', null, { withChildren: true });
